import { Col, Row } from 'antd'
import { useState } from 'react'

import { BulkOrderJobsConfiguration } from './Configuration/Configuration'
import { BulkOrderJobsGrid } from './Grid/Grid'
import { BulkOrderJobsLogs } from './Logs/Logs'
import { useSetup } from '@api/useSetup'

export const BulkOrderJobs: React.FC = () => {
  const [selectedJobId, setSelectedJobId] = useState<string | null>(null)
  const { data: setup } = useSetup()
  const showLeftPane = false
  //  const showLeftPane = setup?.debug  // TODO bring this back when we revisit this page

  return (
    <div className='h-full p-3'>
      <Row className='flex h-100 pb-4'>
        {showLeftPane && (
          <Col span={6} className='flex-1' style={{ display: 'flex', flexDirection: 'column' }}>
            <span className='section-title mt-1'>BULK ORDER JOBS</span>
            <BulkOrderJobsConfiguration />
          </Col>
        )}
        <Col
          className='vertical-flex'
          style={{ height: 'auto', marginLeft: showLeftPane ? '16px' : '0' }}
          span={showLeftPane ? 18 : 24}
        >
          <span className='section-title mt-1 pl-3'>LOGS</span>
          <BulkOrderJobsLogs jobId={selectedJobId} />
          <BulkOrderJobsGrid onJobSelect={setSelectedJobId} selectedJobId={selectedJobId} />
        </Col>
      </Row>
    </div>
  )
}
